import Vue from 'vue';
import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import cloneDeep from 'lodash/cloneDeep';
import { saveAs } from 'file-saver';
import { fetchEnumsFromSchema } from '@/core/tools/forms/fetch_enums_from_schema';
import moment from "moment";

interface ShiftVDPFactState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    documentId: any;
    clientId: any;
    meta: any;

    // productList: any[];
    // productVariantList: any[];
    prefereds: any;
    relatedFactsList: any[];

    targetForDelete: any[];
    // inWorkStatus: any;
    // formationStatus: any;
    // products: any[];
    remains: any[];
}

const state: ShiftVDPFactState = {
    loading: false,
    loaded: false,
    fatalError: false,

    documentId: null,
    clientId: null,
    meta: null,

    // productList: [],
    // productVariantList: [],
    prefereds: [],
    relatedFactsList: [],

    targetForDelete: [],
    // products: [],
    remains: []
};

const initState: any = cloneDeep(state);

const GET_SHIFT_FACT_VDP = 'GET_SHIFT_FACT_VDP';
const GET_SHIFT_FACT_WASH = 'GET_SHIFT_FACT_WASH';
const GET_SCHEMA_FACT_VDP = 'GET_SCHEMA_FACT_VDP';


export const actions: ActionTree<ShiftVDPFactState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    loadData({ commit, getters, dispatch, state }, { documentId, clientId, remains }) {
        const vm = (this as any)._vm;

        state.documentId = documentId;
        state.clientId = clientId;
        state.remains = remains;

        return new Promise((resolve, reject) => {
          commit('START_LOADING');
          vm.$db([
            vm.$q(GET_SHIFT_FACT_VDP)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'sjv.id',
                  fact_id: 'sjv.fact_id',
                  base_name: {$concat: ['base.name', {$: ' '}, 'vst.name']},
                  base_id: 'base.id',
                  water: 'sjv.water',
                  water_temp: 'sjv.water_temp',
                  ferment_temp: 'sjv.ferment_temp',
                  heat_to: 'sjv.heat_to',
                  delay: 'sjv.delay',
                  homogen_time: 'sjv.homogen_time',
                  pressure: 'sjv.pressure',
                  quantity: 'sjv.quantity',
                  weight: 'sjv.weight',
                  start_time: 'sjv.start_time',
                  ferment_time: 'sjv.ferment_time',
                  homoget_time: 'sjv.homoget_time',
                  inertia: 'sjv.inertia',
                  frozen_time: 'sjv.frozen_time',
                  acidity: 'sjv.acidity',
                  acidity_fact: 'sjv.acidity_fact',
                  recomended_ferment_time: 'sjv.recomended_ferment_time',
                  number: 'spv.number',
                  ignore_done_delay: 'spv.ignore_done_delay',
                  ferment_delay: 'base.ferment_delay',
                  how_shift: 'sjv.how_shift',
                  diff_causticity: 'sjv.diff_causticity',
                  pressure_diff: 'sjv.pressure_diff',
                  pressure_healt: 'sjv.pressure_healt',
                  pressure_cold: 'sjv.pressure_cold',
                  corrector_name: 'vc.name',
                  corrector_added_at: 'sjv.corrector_added_at',
                  corrector_quantity: 'sjv.corrector_quantity',
                  starter_type_name: 'jvst.name',
                  starter_type_added_at: 'sjv.starter_type_added_at',
                  starter_type_quantity: 'sjv.starter_type_quantity',
                  regulator_name: 'vr.name',
                  regulator_added_at: 'sjv.regulator_added_at',
                  regulator_quantity: 'sjv.regulator_quantity',
                  caucity_avg: 'sjv.caucity_avg',
                  extract_time: 'sfv.extract_time',
                  mark_temp: 'vbm.temp',
                  mark_acidity: 'vbm.acidity',
                  volume_type: 'vv.type',
                },
                from: 's:shift_journal_vdp',
                from_as: 'sjv',
                joins: [
                  {
                    join: 's:shift_fact_vdp',
                    type: 'left',
                    as:   'sfv',
                    on: {
                      $eq: ['sjv.fact_id', 'sfv.id']
                    }
                  },
                  {
                    join: 's:shift_plan_vdp',
                    type: 'left',
                    as:   'spv',
                    on: {
                      $eq: ['sfv.shift_plan_id', 'spv.id']
                    }
                  },
                  {
                    join: 's:voc_bases',
                    type: 'left',
                    as:   'base',
                    on: {
                      $eq: ['spv.base_id', 'base.id']
                    }
                  },
                  {
                    join: 's:voc_starter_types',
                    type: 'left',
                    as:   'vst',
                    on: {
                      $eq: ['vst.id', 'spv.starter_type_id']
                    }
                  },
                  {
                    join: 's:view_base_mark',
                    type: 'left',
                    as:   'vbm',
                    on: {
                      $eq: ['vbm.id', 'sfv.id']
                    }
                  },
                  {
                    join: 's:voc_correctors',
                    type: 'left',
                    as:   'vc',
                    on: {
                      $eq: ['vc.id', 'sjv.corrector_id']
                    }
                  },
                  {
                    join: 's:voc_starter_types',
                    type: 'left',
                    as:   'jvst',
                    on: {
                      $eq: ['jvst.id', 'sjv.starter_type_id']
                    }
                  },
                  {
                    join: 's:voc_regulators',
                    type: 'left',
                    as:   'vr',
                    on: {
                      $eq: ['vr.id', 'sjv.regulator_id']
                    }
                  },
                  {
                    join: 's:voc_lines',
                    type: 'left',
                    as:   'vl',
                    on: { 
                      $eq: ['vl.id', 'spv.line_id']
                    }
                  },
                  {
                    join: 's:voc_volumes',
                    type: 'left',
                    as:   'vv',
                    on: {
                      $eq: ['vv.id', 'vl.volume_id']
                    }
                  },
                ],
                order: [
                  {$asc: ['sjv.id']}
                ],
                where: {
                  $and: [
                    {$eq: [`spv.shift_id`, {$: documentId}]},
                    {$null: [`spv.deleted_at`]}
                  ]
                }
              }),
            vm.$q(GET_SHIFT_FACT_WASH)
              .raw('documents.list')
              .action({
                columns: {
                  id: 'sjw.id',
                  number: 'spw.number',
                  product_name: 'vv.name',
                  wash_type: 'vwt.name',
                  water_volume: 'vvw.water_volume',
                  detergent_volume: 'vvw.detergent_volume',
                  detergent_concentration: 'vvw.detergent_concentration',
                  detergent_name: 'vd.name',
                  begin_datetime: 'sjw.begin_datetime',
                  end_datetime: 'sjw.end_datetime',
                },
                from: 's:shift_journal_washing',
                from_as: 'sjw',
                joins: [
                  {
                    join: 's:shift_plan_washing',
                    type: 'left',
                    as:   'spw',
                    on: {
                      $eq: ['sjw.plan_washing_id', 'spw.id']
                    }
                  },
                  {
                    join: 's:voc_volumes',
                    as:   'vv',
                    on: {
                      $eq: ['vv.id', 'spw.equipment_id']
                    }
                  },
                  {
                    join: 's:voc_volumes_washings',
                    as:   'vvw',
                    on: {
                      $eq: ['vvw.id', 'spw.washing_id']
                    }
                  },
                  {
                    join: 's:washings',
                    as:   'w',
                    on: {
                      $eq: ['w.id', 'vvw.washing_id']
                    }
                  },
                  {
                    join: 's:voc_washing_types',
                    as:   'vwt',
                    on: {
                      $eq: ['vwt.id', 'w.type_id']
                    }
                  },
                  {
                    join: 's:voc_detergents',
                    as: 'vd',
                    on: {
                      $eq: ['vd.id', 'w.detergent_id']
                    }
                  }
                ],
                order: [
                  {$asc: ['sjw.id']}
                ],
                where: {
                  $and: [
                    {$eq: [`spw.shift_id`, {$: documentId}]},
                    // {$null: [`spv.deleted_at`]}
                  ]
                }
              }),
              vm.$q(GET_SCHEMA_FACT_VDP)
              .raw('schemas.get')
              .action({
                  id: `s:shift_journal_vdp`
              }),
          ]).then((result: ServerResult) => {
            const opRelResult = result.getOperation(GET_SHIFT_FACT_VDP);
            const opWashResult = result.getOperation(GET_SHIFT_FACT_WASH);
            if (!opRelResult.hasError()) {
              state.relatedFactsList = opRelResult.getContent().documents.map((item: any) => {
                item.type = 'vdp'
                item.fermentation_time = null
                if (item.extract_time && item.ferment_time) {
                  const _start = moment('1970-01-01 00:00:00').add(moment.duration(moment(item.extract_time).diff(moment(item.ferment_time))))
                  item.fermentation_time = _start.format('HH:mm:ss')
                }
                let done_to_cook = null;
                if (item.frozen_time) {
                  done_to_cook =  moment(item.frozen_time)
                  if (item.ignore_done_delay) {
                    done_to_cook = done_to_cook.add(item.ferment_delay.secs, 'seconds').utc().local().format('YYYY-MM-DD HH:mm:ss')
                  }
                }
                item.done_to_cook = done_to_cook
                return item
              })
              state.relatedFactsList.push(...opWashResult.getContent().documents.map((doc: any) => {
                doc.type = 'wash'
                return doc
              }))
            }
            const opRelSchema = result.getOperation(GET_SCHEMA_FACT_VDP);
            if (!opRelSchema.hasError()) {
              state.meta = fetchEnumsFromSchema(opRelSchema.getContent().schema)
            }

            commit('LOADED_SUCCESS');
            resolve(null);
          });
        })
    },

    exportAsXLSX({rootState, state}, {documentId}) {
      const vm = (this as any)._vm;

      return new Promise((resolve, reject) => {
          vm.$db([
              vm.$q('EXPORT')
              .raw('documents.report')
              .action({
                template: `
<!DOCTYPE html>
<table font=Verdana font-size=10 orientation="portrait" area="A:K" scale="45">
<tr height=30>
  <td wrap border bold bgcolor=FF72BF44 width=30>Наименование базы</td>
  <td wrap border bold bgcolor=FF72BF44 width=25>Вода, л</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Температура воды, градусы</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Температура заквашивания, градусы</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Нагрев до</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Выдержка</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Время гомогенизации</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Давление</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Количество ведер</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Чистый вес</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Время начала</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Время заквашивания</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Время начала гомогенизации</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>pH смеси</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>pH после созревания полупродукта</td>
  <td wrap border bold bgcolor=FF72BF44 width=20>Рекомендуемое время выемки</td>
</tr>
{{#facts.documents}}
  <tr height="auto">
    <td wrap border base >{{base_name}}</td>
    <td wrap border base type=number round align=center>{{water}}</td>
    <td wrap border base align=center>{{water_temp}}</td>
    <td wrap border base round align=center>{{ferment_temp}}</td>
    <td wrap border base round align=center>{{heat_to}}</td>
    <td wrap border base round align=center>{{delay}}</td>
    <td wrap border base type="time" round align=center>{{homogen_time}}</td>
    <td wrap border base round align=center>{{pressure}}</td>
    <td wrap border base type=number align=center>{{quantity}}</td>
    <td wrap border base type=number align=center>{{weight}}</td>
    <td wrap border base type="date" align=center>{{start_time}}</td>
    <td wrap border base type="date" align=center>{{ferment_time}}</td>
    <td wrap border base type="date" align=center>{{homoget_time}}</td>
    <td wrap border base align=center>{{acidity}}</td>
    <td wrap border base align=center>{{acidity_fact}}</td>
    <td wrap border base type="date" align=center>{{recomended_ferment_time}}</td>
  </tr>
{{/facts.documents}}
</table>
                `,
                queries: {
                  facts: {
                    columns: {
                      id: 'sjv.id',
                      fact_id: 'sjv.fact_id',
                      base_name: {$concat: ['base.name', {$: ' '}, 'vst.name']},
                      base_id: 'base.id',
                      water: 'sjv.water',
                      water_temp: 'sjv.water_temp',
                      ferment_temp: 'sjv.ferment_temp',
                      heat_to: 'sjv.heat_to',
                      delay: 'sjv.delay',
                      homogen_time: 'sjv.homogen_time',
                      pressure: 'sjv.pressure',
                      quantity: 'sjv.quantity',
                      weight: 'sjv.weight',
                      start_time: 'sjv.start_time',
                      ferment_time: 'sjv.ferment_time',
                      homoget_time: 'sjv.homoget_time',
                      number: 'spv.number',
                      mark_temp: 'vbm.temp',
                      mark_acidity: 'vbm.acidity',
                    },
                    from: 's:shift_journal_vdp',
                    from_as: 'sjv',
                    joins: [
                      {
                        join: 's:shift_fact_vdp',
                        type: 'left',
                        as:   'sfv',
                        on: {
                          $eq: ['sjv.fact_id', 'sfv.id']
                        }
                      },
                      {
                        join: 's:shift_plan_vdp',
                        type: 'left',
                        as:   'spv',
                        on: {
                          $eq: ['sfv.shift_plan_id', 'spv.id']
                        }
                      },
                      {
                        join: 's:voc_bases',
                        type: 'left',
                        as:   'base',
                        on: {
                          $eq: ['spv.base_id', 'base.id']
                        }
                      },
                      {
                        join: 's:voc_starter_types',
                        type: 'left',
                        as:   'vst',
                        on: {
                          $eq: ['vst.id', 'spv.starter_type_id']
                        }
                      },
                      {
                        join: 's:view_base_mark',
                        type: 'left',
                        as:   'vbm',
                        on: {
                          $eq: ['vbm.id', 'sfv.id']
                        }
                      },
                    ],
                    order: [
                      {$asc: ['sjv.id']}
                    ],
                    where: {
                      $eq: [`spv.shift_id`, {$: documentId}]
                    }
                  },
                },
                format: 'xlsx'
              })
          ]).then(((result: ServerResult) => {
              const exportOpContent = result.getOperation('EXPORT').getContent();
              const fToken = exportOpContent.token;
              const aToken = (rootState as any).ubic.token
              const fileUrl = `${process.env.VUE_APP_UBIC_SERVER_ADDRESS}/api/v1/exports/${fToken}?authorization=${aToken}`;
              saveAs(fileUrl, 'export.xlsx')

              resolve();
          }));
      })
    }
};

export const mutations: MutationTree<ShiftVDPFactState> = {
  RESET_STATE: (state) => {
      for(const key in initState) {
          (state as any)[key] = initState[key]
      }
  },
  START_LOADING: (state) => {
      state.loaded = false;
      state.loading = true;
      state.fatalError = false;
  },
  LOADED_SUCCESS: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = false;
  },
  LOADED_ERROR: (state) => {
      state.loaded = true;
      state.loading = false;
      state.fatalError = true;
  },

  // SET_DEAL_DATA(state, data) {
  //     const schema = data.schema;
  //     const document = data.documents[0];

  //     state.document = document
  // },

  // SET_DEAL_PRODRUCTS(state, data) {
  //     state.products = data.documents;
  // },

  // SET_STATUSES_INFO(state, {inWorkStatus, formationStatus}) {
  //     state.inWorkStatus = inWorkStatus;
  //     state.formationStatus = formationStatus;
  // },
};

export const getters: GetterTree<ShiftVDPFactState, RootState> = {
  totals : (state: ShiftVDPFactState) => {
    return {
      sum: state.relatedFactsList.reduce((val: number, item: any) => {
        return val + (parseFloat(item.container_price) || 0)
      }, 0)
    }
  },
  rotateJournal: (state: ShiftVDPFactState) => {
    return state.relatedFactsList.reduce((prev: any, item: any) => {
      Object.keys(item).map((key: any) => {
        if (!prev[key]){
          prev[key] = [];
        }
        prev[key].push(item[key]);
      })
      prev.rows.push(item)
      return prev
    }, {rows: []})  
  }
};

export const STORE_KEY = '$_shift_vdp_journal_list';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
